import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["estimateSelect"]

    change(event) {
        const projectId = event.target.value
        if (!projectId) {
            this.estimateSelectTarget.innerHTML = '<option value="">Select Project First</option>'
            return
        }

        // Fetch estimates for the selected project
        fetch(`/projects/${projectId}/estimates.json`)
            .then(response => response.json())
            .then(data => {
                this.estimateSelectTarget.innerHTML = '<option value="">Select Estimate</option>'
                data.forEach(estimate => {
                    const option = document.createElement("option")
                    option.value = estimate.id
                    option.text = estimate.title
                    this.estimateSelectTarget.add(option)
                })
            })
    }
}